import { Component, Input, OnInit } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import { JsonSchemaFormService } from '@ajsf/core';
import { EENumberBoxOptions, EETextBoxLayoutNode } from '../text-box/ee-widget-options.model';
import { JsfUtilsService } from '@xm-ngx/ext/ee-core-webapp-ext/jsf-module/jsf-utils.service';

@Component({
  selector: 'xm-number-box',
  standalone: false,
  templateUrl: './number-box.component.html',
  styleUrls: ['./number-box.component.scss']
})
export class NumberBoxComponent implements OnInit {

  @Input() public layoutNode: EETextBoxLayoutNode;

  public options: Partial<EENumberBoxOptions>;
  public controlValue: string;

    public defaultValidationMessages: {[key: string]: string} =
        this.utils.getDefaultValidationMessages();

  public validators: ValidatorFn[];

  constructor(
    private jsf: JsonSchemaFormService,
    protected utils: JsfUtilsService,
  ) { }

  ngOnInit(): void {
    this.options = this.layoutNode && this.layoutNode.options || {};
    this.initValidators();

    this.jsf.initializeControl(this);
  }

  changeText($event) {
    this.jsf.updateValue(this, $event.target.value);
  }

  initValidators() {
    this.validators = [];
    if (this.options.min) {
      this.validators.push(Validators.min(this.options.min));
    }
    if (this.options.max) {
      this.validators.push(Validators.max(this.options.max));
    }
  }

}
